/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_ResendInputs */

const en_signin_resend = /** @type {(inputs: Signin_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend link`)
};

/** @type {(inputs: Signin_ResendInputs) => LocalizedString} */
const ar_signin_resend = en_signin_resend;

/** @type {(inputs: Signin_ResendInputs) => LocalizedString} */
const he_signin_resend = en_signin_resend;

/** @type {(inputs: Signin_ResendInputs) => LocalizedString} */
const ur_signin_resend = en_signin_resend;

/** @type {(inputs: Signin_ResendInputs) => LocalizedString} */
const es_signin_resend = en_signin_resend;

/** @type {(inputs: Signin_ResendInputs) => LocalizedString} */
const fr_signin_resend = en_signin_resend;

/** @type {(inputs: Signin_ResendInputs) => LocalizedString} */
const de_signin_resend = en_signin_resend;

/** @type {(inputs: Signin_ResendInputs) => LocalizedString} */
const pt_signin_resend = en_signin_resend;

/** @type {(inputs: Signin_ResendInputs) => LocalizedString} */
const hi_signin_resend = en_signin_resend;

/** @type {(inputs: Signin_ResendInputs) => LocalizedString} */
const bn_signin_resend = en_signin_resend;

/**
* | output |
* | --- |
* | "Resend link" |
*
* @param {Signin_ResendInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_resend = /** @type {((inputs?: Signin_ResendInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_ResendInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_resend(inputs)
	if (locale === "he") return he_signin_resend(inputs)
	if (locale === "ur") return ur_signin_resend(inputs)
	if (locale === "es") return es_signin_resend(inputs)
	if (locale === "fr") return fr_signin_resend(inputs)
	if (locale === "de") return de_signin_resend(inputs)
	if (locale === "pt") return pt_signin_resend(inputs)
	if (locale === "hi") return hi_signin_resend(inputs)
	if (locale === "bn") return bn_signin_resend(inputs)
	return /** @type {LocalizedString} */ ("Resend link")
});